// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-analysis-description-edit{display:block;padding:15px 20px}.ac-analysis-description-edit__editor{height:160px;line-height:2.1rem;padding:10px;width:100%}.ac-analysis-description-edit__actions{display:flex;margin-top:10px}.ac-analysis-description-edit__cancel,.ac-analysis-description-edit__save{padding-left:15px;padding-right:15px;margin-right:10px}\n", ""]);
// Exports
module.exports = exports;
